export const SET_POOLS = 'SET_POOLS';

export const SET_POOL = 'SET_POOL';

export const REMOVE_POOL = 'REMOVE_POOL';

export const CLEAR_POOLS = 'CLEAR_POOLS';